import _Step from './Step';

import './style/index.js';

export * from './type';

export const Step = _Step;

export default Step;
